import { useMutation } from "@tanstack/react-query";

import { queryClient } from "utils";

import { saveQuestionnaire } from ".";

export function useQuestionnaireMutation(slug: string | undefined) {
  return useMutation({
    mutationKey: ["questionnaire", slug],
    mutationFn: async (questions: Record<string, unknown>[]) => {
      if (!slug) throw new Error("Missing property slug");
      const visitor_uuid = queryClient.getQueryData<string>(["visitorUUID"]);
      if (!visitor_uuid) throw new Error("Missing visitor UUID");
      return saveQuestionnaire(slug, { visitor_uuid, data: { questions } });
    },
  });
}
